module.exports = __webpack_public_path__ + "static/media/PublicTransport.270d7196.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/GuruProfile/PublicTransport.svg
// module id = 2608
// module chunks = 0